import React, { useContext, useState } from 'react';
import { Button, Tooltip } from 'antd';
import { useNavigate } from "react-router-dom";
import { LogoutOutlined } from '@ant-design/icons';
import { logout } from '../../services/auth';
import { BiLogOutCircle} from "react-icons/bi";
import { RootContext } from '../../context/RootContext';

export default function Logout() {
  const [isLoading] = useState(false);
	const { dispatch } = useContext(RootContext);

  const navigate = useNavigate();

  const logouts = ()=>{
    logout()
    dispatch({type: 'LOGOUT'});
    navigate('/login');
  }

  return (
    <Tooltip title="Logout" placement="bottom">
      <Button 
        shape="circle"
        loading={isLoading}
        className="text-sky-700 flex"
        onClick={logouts}
        icon={<BiLogOutCircle size = '24'/>} />
    </Tooltip>
  );
}